import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'demo',
    component: () => import(/* webpackChunkName: "demo" */ '@/views/demo/index.vue'),
    children:[
        {
            path: '/searchContent/:path',
            name: 'searchContent',
            component: () => import(/* webpackChunkName: "searchContent" */ '@/views/demo/searchContent.vue'),
           
          },
    ]
  },
  
 
];

const router = new VueRouter({
  mode: 'hash',
  routes,
});

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default router;

